import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarMinimalActionsDropdownContentWireframe from './VeltCommentsSidebarMinimalActionsDropdownContentWireframe/VeltCommentsSidebarMinimalActionsDropdownContentWireframe';
import VeltCommentsSidebarMinimalActionsDropdownTriggerWireframe from './VeltCommentsSidebarMinimalActionsDropdownTriggerWireframe/VeltCommentsSidebarMinimalActionsDropdownTriggerWireframe';
var VeltCommentsSidebarMinimalActionsDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarMinimalActionsDropdownWireframe.Trigger = VeltCommentsSidebarMinimalActionsDropdownTriggerWireframe;
VeltCommentsSidebarMinimalActionsDropdownWireframe.Content = VeltCommentsSidebarMinimalActionsDropdownContentWireframe;
export default VeltCommentsSidebarMinimalActionsDropdownWireframe;
